<div class="graficos">
 <div class="fila-graficos1">
   <div *ngIf="!basica" class="chart-inicio" >
      <h2 [routerLink]="['/cliente/instalaciones']">{{ title_instalaciones }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasInstalaciones class="chartjs-render-monitor" (click)="showDataInstalaciones($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-inicio" >
      <h2 [routerLink]="['/cliente/contratistas']">{{ title_contratistas }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasContratistas class="chartjs-render-monitor" (click)="showDataContratistas($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-inicio" >
      <h2 [routerLink]="['/cliente/centros']">{{ title_centros }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasCentros class="chartjs-render-monitor" (click)="showDataCentros($event)"></canvas>
          </div>
          <div>
          <ng-container *ngIf="nombreArchivoOne || nombreArchivoTwo || nombreArchivoThr">
          
          <h4 [routerLink]="['/cliente/centros']">Documentación Adicional</h4>
          <div class="doc-adicional">
          <div class="doc-adicional__item">
          <h5 [routerLink]="['/cliente/centros']">{{nombreArchivoOne}}</h5>
          
           <div class="canvas-mini">
            <canvas #doughnutCanvasAdicOneCentros class="chartjs-render-monitor" ></canvas>
          </div>
          </div>
          <div class="doc-adicional__item">
          <h5 [routerLink]="['/cliente/centros']">{{nombreArchivoTwo}}</h5>
          
           <div class="canvas-mini">
            <canvas #doughnutCanvasAdicTwoCentros class="chartjs-render-monitor" ></canvas>
          </div>
          </div >
          <div class="doc-adicional__item">
          <h5 [routerLink]="['/cliente/centros']">{{nombreArchivoThr}}</h5>
          
           <div class="canvas-mini">
            <canvas #doughnutCanvasAdicThrCentros class="chartjs-render-monitor" ></canvas>
          </div>
          </div>
        </div>
      </ng-container>
    </div>
        </div>
      </div>
    </div>
    <!-- <div class="chart-inicio"" [routerLink]="['/inproeco/estado/clientes']">
        <h2>{{ title_clientes }}</h2>
        <div class="container">
          <div>
            <div>
              <canvas #doughnutCanvasClientes></canvas>
            </div>
          </div>
        </div>
      </div> -->
  </div>
  <div class="fila-graficos2">
    <div class="chart-inicio" >
      <h2 [routerLink]="['/cliente/gestores']">{{ title_gestores }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasGestores class="chartjs-render-monitor" (click)="showDataGestores($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-inicio" >
      <h2 [routerLink]="['/cliente/transportista']">{{ title_transportistas }}</h2>
      <div class="container">
        <div>
          <div>
            <canvas #doughnutCanvasTransportistas class="chartjs-render-monitor" (click)="showDataTransportistas($event)"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<p>
  <!--  <canvas #canvasNetWorth>{{ chart }}</canvas> -->
</p>
